let read_more = document.querySelector('.read-additional')
let description = document.getElementById('product-description');

if (read_more) {
  read_more.addEventListener('click', showHideDescription)
}

function showHideDescription() {
  description.classList.toggle('active')
  if (description.classList.contains('active')) {
    read_more.innerText = 'ראה פחות'
  } else {
    read_more.innerText = 'קרא עוד'
  }
}

function openGift() {
  const giftModal = document.querySelector('#GiftModal')
  if (giftModal.classList.contains("modal--is-active")) {
    giftModal.classList.remove("modal--is-active");
  } else {
   giftModal.classList.add("modal--is-active");
  }
}

function closeGift() {
  document.querySelector('#GiftModal').classList.remove('modal--is-active')
}


function add_gift_wrap(e, el) {
    const note = $('.GiftWrap__Note')
    let variant = "39357200826451"
    const giftModal = document.querySelector('#GiftModal')
    e = e || window.event;
    e.preventDefault();

    /*$(".gift_wrap_checkbox:checkbox").each(function() {
      if ($(this).is(':checked')) {
        variant = $(this)
      }
    })*/

    const formData = {
      items: [
        {
          id: variant,
          quantity: 1,
          properties: {
            'ברכה': note.val()
          }
        }
      ]
    };

    el.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(resp => resp.json())
      .then(data => {
        location.reload();
      })
      .catch(err => {
        console.error('Error: ', err);
      });
      giftModal.classList.remove("modal--is-active");
}